import { logHttpError } from '@/core/utils/http-error-logger';
import * as v2 from '@/core/services/api/v2';

const state = {
  inventory: {
    fish: [],
    rods: [],
    baits: [],
    boats: [],
    licenses: []
  },
  equipment: {
    rod: null,
    boat: null
  }
};

const mutations = {
  SET_INVENTORY(state, inventory) {
    state.inventory = inventory;
  },
  SET_EQUIPMENT(state, equipment) {
    state.equipment = equipment;
  },
  UPDATE_PLAYER_DATA(state, playerData) {
    if (playerData.inventory) {
      state.inventory = typeof playerData.inventory === 'string' 
        ? JSON.parse(playerData.inventory) 
        : playerData.inventory;
    }
    if (playerData.equipment) {
      state.equipment = typeof playerData.equipment === 'string'
        ? JSON.parse(playerData.equipment)
        : playerData.equipment;
    }
  }
};

const actions = {
  /**
   * Carrega inventário e equipamento do V2.
   *
   * São duas rotas agora, não uma: `GET /player/:id` traz o equipamento junto do
   * perfil, e `GET /player/:id/inventory` traz os peixes, paginados por cursor.
   * `v2.carregarJogador` faz as duas em paralelo e devolve já unificado.
   *
   * O inventário do V2 é **só peixe**. Vara, barco e casa viraram equipamento
   * (`player_gear`) e isca virou item empilhável, e nenhum dos dois é listado por
   * esta rota — as categorias vazias existem para as telas que ainda as leem.
   */
  async initializeInventory({ commit }, playerId) {
    try {
      const jogador = await v2.carregarJogador(playerId);
      commit('UPDATE_PLAYER_DATA', jogador);
      return jogador;
    } catch (error) {
      logHttpError(error, {
        method: 'GET',
        url: `/api/player/${playerId}`,
        data: {}
      });
      throw error;
    }
  },

  // `addItemToInventory`, `removeItemFromInventory` e `getInventoryByCategory`
  // saíram (05/09/2026): apontavam para rotas do Strapi que o V2 não tem — o
  // inventário muda por consequência de ação, nunca por ordem direta — e não
  // tinham chamador.

  /**
   * Auto-equipar a primeira peça da categoria, no V2.
   *
   * A rota antiga (`inventory/auto-equip`) não existe mais: equipar é
   * `POST /player/:id/gear/equip`, e quem sabe escolher a peça é a store do
   * jogador. Delegar mantém uma implementação só.
   */
  async autoEquipFirstItem({ dispatch }, category) {
    if (category === 'rods') {
      return dispatch('player/autoEquipRod', null, { root: true });
    }
    if (category === 'boats') {
      return dispatch('player/autoEquipBoat', null, { root: true });
    }
    return null;
  }
};

const getters = {
  getInventory: (state) => state.inventory,
  getEquipment: (state) => state.equipment,
  getItemsByCategory: (state) => (category) => state.inventory[category] || [],
  getEquippedItems: (state) => state.equipment
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};